import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_26: FaireProductEntity = {
  token: "catalog_prod_prod-26",
  type: "product",
  name: "Decorative Item B",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 41.95,
  msrpDollars: 104.88,
  sku: "PA0026",
  caseSize: 2,
  material: "Wood",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 342,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_coffee-tea"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
